"use client";

import { cn } from "@heroui/theme";
import { useTranslations } from "next-intl";

export const JokerIcon = ({ className }: { className?: string }) => {
  const t = useTranslations();
  return (
    <span
      className={cn(className, "text-2xl inline-block")}
      aria-label={t("common.jokerCard")}
    >
      🃏
    </span>
  );
};
export const BraveheartIcon = ({ className }: { className?: string }) => {
  const t = useTranslations();
  return (
    <span
      className={cn(className, "text-2xl inline-block")}
      aria-label={t("common.braveheartCard")}
    >
      💪
    </span>
  );
};
